import React from 'react';

import { Footer } from './Footer';
import { Header } from './Header';

interface Props {
  children: React.ReactNode;
}

const Layout: React.FunctionComponent<Props> = ({ children }) => {
  return (
    <div>
      <Header />
      <div className={'container-fluid m-0 p-0'}>
        <div className={'row m-0 p-0'}>{children}</div>
      </div>
      <Footer />
    </div>
  );
};
export default Layout;
